import { ReactNode } from 'react';

import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import { getCertificateFormData } from '../api';
import { NonStructuredCertificateFormData } from '../types';

const {
  FetchProvider: CertificateFormDataProvider,
  useFetch: useCertificateFormData,
} = createFetchContext<undefined, NonStructuredCertificateFormData>();

interface Props {
  children: ReactNode;
  fetchImmediately?: boolean;
}

export const CertificateFormDataLoader = ({
  children,
  fetchImmediately = true,
}: Props) => {
  return (
    <CertificateFormDataProvider
      request={getCertificateFormData}
      fetchImmediately={fetchImmediately}
      defaultQuery={undefined}
    >
      {children}
    </CertificateFormDataProvider>
  );
};

export { useCertificateFormData };
